import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateOrgConfig } from '@/services/admin/update-org-config';
import { OrgAdminCatalogItem } from '@/services/admin/get-org-admin-catalog';
import { useNodeStore } from '@/stores/node-store';

interface UpdateOrgConfigParams {
  orgId: string;
  items: Record<string, boolean>;
}

export const useUpdateOrgConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orgId, items }: UpdateOrgConfigParams) =>
      updateOrgConfig(orgId, items),
    onSuccess: (_, { orgId, items }) => {
      queryClient.setQueryData<OrgAdminCatalogItem[]>(
        ['org-admin-catalog', orgId],
        (old) =>
          old?.map((item) =>
            item.node_id in items
              ? { ...item, enabled_by_org: items[item.node_id] }
              : item,
          ),
      );
      useNodeStore.getState().clearNodeCache();
    },
  });
};
